import { PhoneNumberType, PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isPhoneValid = (phone: string): boolean => {
    if (!phone?.trim()) {
        return true;
    }

    const allowedCountries = ['US', 'CA', 'DK'];

    try {
        const parsedPhone = phoneUtil.parseAndKeepRawInput(phone);
        if (!parsedPhone.getNationalNumber()) {
            return true;
        }

        const code = phoneUtil.getRegionCodeForNumber(parsedPhone);

        return (
            phoneUtil.isValidNumber(parsedPhone) &&
            (code && allowedCountries.includes(code)
                ? phoneUtil.getNumberType(parsedPhone) ===
                  PhoneNumberType.FIXED_LINE_OR_MOBILE
                : phoneUtil.getNumberType(parsedPhone) ===
                  PhoneNumberType.MOBILE)
        );
    } catch {
        return false;
    }
};
